import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { DASHBOARD_ROUTE } from "../../../../../routes";
import authServices from "../../../../../services/authServices";
import dataProvider from "../../../../../services/dataProvider";
import AssociatedTask from "../../../common/associated-task";
import { markTaskComplete } from "../../../common/mark-task-complete";
import { SUBMITTED_FORMS_ROUTE } from "../../../dashboard-routes";
import getAssociatedTask from "../getAssociatedTask";
import SelfDeclaration from "./common/self-declaration";
import YesNoFormGenerator from "./common/yesno-form-generator";
import { sg3MonthlyChecklistLicenseeFormMap } from "./form-maps/sg3-monthly-checklist-licensee-form-map";

const SG3MonthlyChecklistLicenseeForm = ({ bucket, formType, formTitle }) => {
    const history = useHistory();
    const location = useLocation();

    let baseState = {
        formType,
        formTitle,
        bucket,
        nameOfPersonCompletingForm: "",
        dateOfFormCompletionInString: "",
        dateOfFormCompletionInMilliSeconds: 0,
        tncAgreed: false,
        month: 0,
    };

    const [formState, setFormState] = useState(baseState);
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [associatedTask, setAssociatedTask] = useState(null);
    const [completeTask, setCompleteTask] = useState(true);

    useEffect(() => {
        if (location?.state?.editForm === true) {
            if (location?.state?.formState) {
                setEditMode(true);
                let editFormState = location.state.formState;

                // add all extra fields that is not in formMap
                let cleanEditFormData = {
                    formType,
                    formTitle,
                    bucket,
                    nameOfPersonCompletingForm: editFormState.nameOfPersonCompletingForm,
                    dateOfFormCompletionInString: editFormState.dateOfFormCompletionInString,
                    tncAgreed: editFormState.tncAgreed === "true",
                    dateOfFormCompletionInMilliSeconds: editFormState.dateOfFormCompletionInMilliSeconds,
                    month: editFormState.month,
                    editFormId: editFormState.id,
                };

                // add yes no fields
                let formMap = sg3MonthlyChecklistLicenseeFormMap;
                Object.keys(formMap).forEach((section) => {
                    formMap[section].forEach((field) => {
                        cleanEditFormData[field.id] = editFormState[field.id] === "true";
                    });
                });

                setFormState(cleanEditFormData);
                //console.log("Clean Form", cleanEditFormData);
                setIsFetching(true);
                getAssociatedTask(formType)
                    .then((res) => {
                        setIsFetching(false);
                        if (res.data && res.data.length > 0) {
                            let task = res.data[0];
                            setAssociatedTask(task);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });

            } else {
                console.error("Form in Edit Mode but Form State Missing");
                setErrorMsg("Something Went Wrong");
            }
        }
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMsg("");
        setErrorMsg("");

        let endPoint = editMode ? "forms-editFormDetails" : "forms-addFormDetails";
        var data = new FormData();
        var jsonData = {}; // only used for debug purpose

        for (var key in formState) {
            data.append(key, formState[key]);
            jsonData[key] = formState[key];
        }

        //console.log("SENT FROM DATA", jsonData);

        var config = {
            method: "post",
            url: dataProvider.baseUrl + endPoint,
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                setIsLoading(false);
                setSuccessMsg("Form Submitted Successfully");
                if (completeTask && associatedTask) {
                    markTaskComplete(associatedTask.id).then((res) => {
                        if (res.data.status === "success") {
                            history.push({
                                pathname: DASHBOARD_ROUTE + SUBMITTED_FORMS_ROUTE,
                                state: {
                                    successMsg:
                                        editMode === true
                                            ? "Form Updated Successfully"
                                            : "Form Submitted Successfully",
                                },
                            });
                        } else {
                            setErrorMsg("Unable to Complete the Task");
                        }
                    });
                } else {
                    history.push({
                        pathname: DASHBOARD_ROUTE + SUBMITTED_FORMS_ROUTE,
                        state: {
                            successMsg:
                                editMode === true ? "Form Updated Successfully" : "Form Submitted Successfully",
                        },
                    });
                }
                //console.log(response);
            })
            .catch(function (error) {
                setIsLoading(false);
                setErrorMsg(error.message);
                console.error(error);
            });
    }

    return (
        <div id="SGMonthlyChecklistLicenseeForm">
            <div className="container-fluid p-0">
                <div className="card p-4 m-0 no-radius border-0 border-bottom">
                    <h5 className="m-0">{formTitle}</h5>
                </div>
            </div>

            {successMsg && !errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            {isFetching ? (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Form Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="container-fluid p-3">
                        <div className="card p-3">
                            <div className="d-flex justify-content-center">
                                <form className="w-100" style={{ maxWidth: "60rem" }} onSubmit={handleSubmit}>
                                    <div className="row w-100 mt-4 mb-5 align-items-center">
                                        <div className="col-md text-nowrap">
                                            Monthly checklist Licensee – For the Month of
                                        </div>
                                        <div className="col-md mt-3 mt-lg-0">
                                            <select
                                                value={formState.month}
                                                className="form-select m-0"
                                                onChange={(e) =>
                                                    setFormState((fs) => ({ ...fs, month: e.target.value }))
                                                }
                                            >
                                                <option value="0">January</option>
                                                <option value="1">February</option>
                                                <option value="2">March</option>
                                                <option value="3">April</option>
                                                <option value="4">May</option>
                                                <option value="5">June</option>
                                                <option value="6">July</option>
                                                <option value="7">August</option>
                                                <option value="8">September</option>
                                                <option value="9">October</option>
                                                <option value="10">November</option>
                                                <option value="11">December</option>
                                            </select>
                                        </div>
                                    </div>

                                    <YesNoFormGenerator
                                        formMap={sg3MonthlyChecklistLicenseeFormMap}
                                        formState={formState}
                                        setFormState={setFormState}
                                    />

                                    {associatedTask && (
                                        <AssociatedTask
                                            task={associatedTask}
                                            completeTask={completeTask}
                                            setCompleteTask={setCompleteTask}
                                        />
                                    )}

                                    <SelfDeclaration
                                        setFormState={setFormState}
                                        formState={formState}
                                        isLoading={isLoading}
                                        editMode={editMode}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SG3MonthlyChecklistLicenseeForm;
